module.exports = __webpack_public_path__ + "media/lobby_normal2.f85887d1.mp3";